<style lang="stylus" scoped>
  @import '../../assets/style/vars.styl'
  .running-count-page
    display flex
    flex-direction column
    width 100vw
    height 100vh
    background-color #f8f8fb
    // 筛选表单
    .filter-header
      height 90px
      display flex
      align-items center
      padding 0 24px
      background-color #fff
      .reset-btn
        position absolute
        right 24px
        font-size 28px
        color #2a2a30

      .delete-icon
        position absolute
        right 24px
        top 22px
        width 36px
        height 36px
        bg-image("https://oss.turingsenseai.com/15958283257870.png")
        &:active
          opacity .7
      .filter-item
        display flex
        align-items center
        font-size 28px
        color #828393
        // width 180px
        margin-right 100px
        &:active
          opacity .7
        .icon
          margin-left 9px
        .deep-text
          color #1D1D1D
      .filter-icon
        width 22px
        height 22px
        bg-image('https://oss.turingsenseai.com/15906693024889.png')
      .arrow-icon
        // &.down, &.up
        //   background-image url('https://oss.turingsenseai.com/1611129147411175214.png')
        //   background-size contain
        //   background-repeat no-repeat
        //   display inline-block
        //   width 26px
        //   height 13px
        &.down
          background-image url('https://oss.turingsenseai.com/1611129147411175214.png')
          background-size contain
          background-repeat no-repeat
          display inline-block
          width 26px
          height 13px
          transition all ease-in 0.2s
          transform rotate(0) !important
        &.up
          // arrowUp()
          background-image url('https://oss.turingsenseai.com/1611129147411175214.png')
          background-size contain
          background-repeat no-repeat
          display inline-block
          width 26px
          height 13px
          transition all ease-in 0.2s
          transform rotate(180deg) !important
    .data-container
      flex 1
      overflow-y auto
      .data-list-container
        height 100%
        // .data-list
        //   height 100%
      .empty-content
        padding-top 316px
        color #828393
        font-size 28px
        text-align center
    // 筛选面板
    .filter-pop-container
      width 100vw
      padding 0 24rpx
      box-sizing border-box
      .filter-header
        color #202020
        font-size 34px
        line-height 88px
        font-weight 600
      .filter-content
        min-height 246px
        display flex
        justify-content center
        .type-item
          width 162px
          height 88px
          line-height 88px
          border 1px solid #DDDDDD
          border-radius 8px
          color #1d1d1d
          font-size 28px
          margin 24px 15px
          text-align center
          &.active
            color #fff
            background-color #1d1d1d
            border none
      .confirm-btn
        width 100%
        line-height 88px
        font-size 30px
        color white
        background-color #1d1d1d
        text-align center
        &:active
          opacity .8
  // mint-ui 样式覆盖
  .running-count-page >>> .mint-actionsheet-listitem
    height 100px
    font-size 28px
    line-height 100px
    color #1d1d1d
  .running-count-page >>> .mint-datetime-picker
    .picker-toolbar
      height 88px
    .mint-datetime-action
      box-sizing border-box
    .mint-datetime-cancel
      text-align left
      padding-left 40px
      color #666
      font-size 30px
      line-height 88px
    .mint-datetime-confirm
      color #000
      font-size 30px
      line-height 88px
      text-align right
      padding-right 40px
      // 强行隐藏日，仅保留年和月
    .picker-items .picker-slot-center:nth-child(3)
      display none
    // .picker-item
    //   height 96px !important
    //   line-height 96px !important
    // .picker-slot-wrapper
    //   height
  /deep/.mint-actionsheet-list
    padding-bottom 90px !important
    background-color #fff
    .mint-actionsheet-listitem:last-child
      border-bottom: none
</style>
<template>
  <div class="running-count-page">
    <div class="filter-header">
      <p class="filter-item date-filter" @click="$refs.picker.open()">
        <span v-if="dateTime" class="deep-text">{{dateTime | dateTimeString}}</span>
        <span v-else>时间筛选</span>
        <span class="icon arrow-icon down" :class="[showDatePanel ? 'up' : '']"></span>
      </p>
      <p class="filter-item type-filter" @click="popupVisible = true">
        <span v-if="filterType" class="deep-text">{{filterType | filterTypeFilter}}</span>
        <span v-else>分类筛选</span>
        <span class="icon arrow-icon down"></span>
      </p>
      <span v-if="showClear" class="reset-btn" @click="clearForm">重置</span>
      <!-- <span v-if="showClear" class="icon delete-icon" @click="clearForm"></span> -->
    </div>
    <div class="data-container">
      <div v-if="dataList && dataList.length" class="data-list-container">
        <div
          class="data-list"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="infiniteScrollDisabled"
          infinite-scroll-distance="50"
        >
          <record v-for="(item, index) in dataList" :key="index" :item="item"></record>
        </div>
        <list-bottom v-if="dataList.length > 5" :loading="isLoading" :textNomore="isEnd ? '没有更多记录了' : ''"></list-bottom>
      </div>
      <div v-if="!dataList || dataList.length === 0" class="data-list-container empty-content">
        <!-- :loading="isLoading" -->
        暂无数据
        <!-- <empty-page :loading="isLoading"></empty-page> -->
      </div>
    </div>
    <!-- ui 日期选择 -->
    <mt-datetime-picker
      ref="picker"
      v-model="myDateTime"
      type="date"
      :startDate="startDate"
      :endDate="endDate"
      year-format="{value}年"
      month-format="{value}月"
      date-format="{value}日"
      :confirm-text="'完成'"
      :cancel-text="'取消'"
      @confirm="datePickHandler"
    />
    <!-- <mt-popup
      v-model="popupVisible"
      position="bottom">
      <div class="filter-pop-container">
        <p class="filter-header">分类筛选</p>
        <div class="filter-content">
          <span
            v-for="(item, index) in filterList"
            class="type-item"
            :class="[filterType === item.key ? 'active' : '']"
            :key="index"
            @click="typeCheckHandler(item.key)"
          >
          {{item.name}}
        </span>
        </div>
        <div class="filter-footer">
          <div class="confirm-btn">确定</div>
        </div>
      </div>
    </mt-popup> -->
    <mt-actionsheet
      :actions="typeActions"
      :cancelText="''"
      v-model="popupVisible">
    </mt-actionsheet>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { DatetimePicker, Popup, Indicator, Actionsheet } from 'mint-ui'
import { WalletRunningCountTypeMapper, WalletRunningCountTypeList } from '../../common/constant'
import record from './base/record.vue'

// import { testFetch, fetchWalletFlow } from '../../common/api/wallet.js'

export default {
  name: 'runningCount',

  components: {
    'mt-datetime-picker': DatetimePicker,
    'mt-actionsheet': Actionsheet,
    'mt-popup': Popup,
    'record': record
  },

  data () {
    return {
      myDateTime: new Date(Date.now()), // 这个其实没有用 只是为了给 datapicker v-model
      // 展示时间选择面板
      showDatePanel: false,
      // 展示筛选面板
      popupVisible: false,
      // 筛选列表
      // filterList: WalletRunningCountTypeList,
      startDate: new Date('2020/05/01'),
      typeActions: WalletRunningCountTypeList.map((item) => ({
        name: item.label,
        method: this.typeCheckHandler.bind(this, item.value)
      })),
      endDate: new Date()
    }
  },

  computed: {
    ...mapState({
      dateTime: state => state.wallet.runningCountDate,
      filterType: state => state.wallet.runningCountFilterType,
      dataList: state => state.wallet.runningCountDataList,
      isEnd: state => state.wallet.runningCountDataEnd,
      isError: state => state.wallet.runningCountDataError,
      isLoading: state => state.wallet.runningCountDataLoading,
    }),
    infiniteScrollDisabled () {
      return this.isEnd || this.isError || this.isLoading
    },
    showClear () {
      return this.dateTime || this.filterType
    }
    // currentDateString () {
    //   return dayjs(this.dateTime).format('YYYY年M月')
    // }
  },

  watch: {
    // showDatePanel (val) {
    //   val ? this.$refs.picker.open() : this.$refs.picker.close()
    // }
  },

  created () {
    this.pageNum = 1
    this.getData()
  },

  methods: {
    // 清空查询
    clearForm () {
      this.$store.commit('SET_RC_DATE', '')
      this.$store.commit('SET_RC_TYPE', 0)
      setTimeout(this.reloadData)
    },
    datePickHandler (date) {
      this.$store.commit('SET_RC_DATE', date)
      this.reloadData()
    },
    typeCheckHandler (key) {
      this.$store.commit('SET_RC_TYPE', key)
      this.reloadData()
    },
    getData (pageNum = 1) {
      if (pageNum === 1) {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
      }
      const dateMonth = this.dateTime ? dayjs(this.dateTime).format('YYYY/MM') : ''
      this.$store.dispatch('GET_RC_LIST', { pageSize: 10, pageNum, flowType: this.filterType, dateMonth })
    },
    reloadData () {
      this.pageNum = 1
      setTimeout(this.getData)
    },
    loadMore () {
      console.log('more....')
      this.pageNum++
      this.getData(this.pageNum)
    }
  },

  filters: {
    dateTimeString (val) {
      return dayjs(val).format('YYYY年M月')
    },
    filterTypeFilter (val) {
      return { 0: '全部', ...WalletRunningCountTypeMapper }[val].label
    }
  }
}
</script>
